/*eslint-disable */

import {
  mapGetters
} from 'vuex';
import moment from 'moment';

// import commonSocket from '@/commonSocket/';

const $ = window.jQuery = require('jquery'); 


export default {
  name: 'help-support-chat-page',
  components: {},
  props: [],
  data () {
    return {
      submitted:false,
      chatSupportListData:null,
      supportChatInfo:[],
      chatSocket:'',
      userId:'',
      roomChatId:'',
      checkSocketId:'',
      socketCheck:'',
      selectedRoomID:'',
      getUserDetailsID:'',
      listLoading:true,
      selectedUserOfSChat:null,
      search_filter:''
    }
  },
  computed: {
    ...mapGetters([
      'getLbilChatUserListGetter'
    ]),
    getOrgListDetailsFun(){
      this.chatSupportListData = this.$store.getters.getLbilChatUserListGetter.data
      return 
    },
    filteredResources(){
      if(this.search_filter){
        return this.chatSupportListData.filter((item)=>{
          return item.user.first_name.toLowerCase().startsWith(this.search_filter.toLowerCase());
        })
        }else{
          return this.chatSupportListData;
        }
    },
  },
  mounted () {
    this.getOrgListDetailsFun
    if(this.chatSupportListData && this.chatSupportListData.length > 0){
    setTimeout(()=>{
      $('.s_chat_list_item').first().addClass('active');
      document.querySelector('.s_chat_list_item.active').click()
      var elmnt = document.getElementById("messagesItem");
      var y = elmnt.clientHeight;
      $('#support-chat-history-id').scrollTop(y)
    },100)
   }
  },
  methods: {
    getDeafultSelectedItemInfoMethod(){
      $('.s_chat_list_item').first().addClass('active');
      document.querySelector('.s_chat_list_item.active').click()
    },
    dateTimeShown(id){
      $('.msg_shown' + id).parent().toggleClass('time_d_shown')
    },
    socketMsgReadFun(id){
      this.$store.dispatch('msgReadStatusFun', {message_id :id})
    },
    actionSupportChatWithInfoMethod(id, itemInfo){
      this.search_filter= ''
      this.supportChatInfo = []
      $('.sent_list').remove();
      $('.recieved_list').remove();
      this.selectedUserOfSChat = itemInfo
      var chatId = this.selectedUserOfSChat.user.id
      this.submitted = true
      this.selectedRoomID = id
      var messagesList = document.getElementById('messagesItem');
      if(chatId != this.getUserDetailsID){
        this.$store.dispatch('getAdminChatDetailsByIdFun', {id:id}).then((res) => {
          this.supportChatInfo = res.data.data
          $('.recieved_list').remove()
          $('.sent_list').remove()
          if(this.supportChatInfo && this.supportChatInfo.length > 0){
            this.$store.dispatch('msgReadStatusFun', {message_id : this.supportChatInfo.slice(-1)[0].id}).then((res)=>{
            }).catch((err)=>{
            })
          }
          var elmnt = document.getElementById("support-chat-history-id");
          var y = elmnt.scrollHeight;
          setTimeout(() => {
            $('#support-chat-history-id').animate({scrollTop: y},20)
          },100)
        })
      }
      let data = {
        users : [chatId],
        is_support_chat : true
      }
      this.$store.dispatch('chatRoomCreatedFun', data).then((res)=>{
        var chatId = res.data.data.id
        this.getUserDetailsID = res.data.data.to_user
        this.roomChatId = chatId.replace(/-/g, "")
        if(this.checkSocketId){
          if(this.roomChatId != this.checkSocketId){
            this.socketCheck.close();
          }
         }
        if(this.roomChatId != this.checkSocketId){
        var socketCheck = new WebSocket(
          'wss://' + process.env.VUE_APP_WEBSOCKET_BASE_URL +
          '/ws/chat/' + this.roomChatId + '/'
        );
        this.checkSocketId = socketCheck.url.split('/')[5]
        this.socketCheck = socketCheck
        socketCheck.onclose = function(e) {
        };
        var _self = this
        var timeout;
        socketCheck.onmessage = function(e) {
          var data = JSON.parse(e.data);
          var message = JSON.parse(data.message );
          var li = document.createElement("li");
          var span = document.createElement("p");
          span.appendChild(document.createTextNode(message.chat_data.message));
          var time = document.createElement("time");
          let dateTimeAdd = [moment(message.chat_data.created_at).format('h:mm a')];
          _self.socketMsgReadFun(message.chat_data.message_id)
          time.appendChild(document.createTextNode(dateTimeAdd));
          time.setAttribute("class", "msg_time");
          li.appendChild(time);
          li.appendChild(span);
          li.setAttribute("class", message.chat_data.type + '_list');
          messagesList.appendChild(li);
          var elmnt = document.getElementById("support-chat-history-id");
          var y = elmnt.scrollHeight;
          setTimeout(() => {
          $('#support-chat-history-id').scrollTop(y)
          },100)
        };
        document.querySelector('#chat-message-reply-input').focus();
        document.querySelector('#chat-message-reply-input').onkeyup = function(e) {
          var messageInputDom = document.querySelector('#chat-message-reply-input');
            if (e.keyCode === 13) {  // enter, return
                document.querySelector('#chat-message-reply-submit').click();
            }else {
              // if (messageInputDom.value.length > 0) {
              //   var sentUserInfo = _self.supportChatInfo[0].chat_room_user.user
              //   videoSocketRef.emit({
              //     type: "TypingEventForSelectedUser",
              //     message: 'typing',
              //     targetForChatUserId: sentUserInfo.id,
              //     second_user_id: sentUserInfo.id,
              //     is_support_chat:true
              //   });
              //   clearTimeout(timeout)
              //   timeout = setTimeout(() => {
              //     videoSocketRef.emit({
              //       type: "TypingEventForSelectedUser",
              //       message: 'stop',
              //       selfUserID: _self.selfUserId,
              //       targetForChatUserId: sentUserInfo.id,
              //       second_user_id: sentUserInfo.id
              //     })
              //   }, 2000)
              // }
            }
        };
        document.querySelector('#chat-message-reply-submit').onclick = function(e) {
          var messageInputDom = document.querySelector('#chat-message-reply-input');
          var message = messageInputDom.value; 
          if(message.length > 0){
          var sentUserInfo = _self.supportChatInfo[0].chat_room_user.user
          let sentData = {
            'message': message,
            type:'recieved',
            email:sentUserInfo.email,
            name:sentUserInfo.first_name + ' ' + sentUserInfo.last_name,  
          }
          socketCheck.send(JSON.stringify({ 'message': message, 'user':sentUserInfo.id, 'chat_data':sentData}));
          // videoSocketRef.emit({
          //   type: "TypingEventForSelectedUser",
          //   message: 'stop',
          //   selfUserID: _self.selfUserId,
          //   targetForChatUserId: sentUserInfo.id,
          //   second_user_id: sentUserInfo.id
          // })
          messageInputDom.value = '';
          var elmnt = document.getElementById("support-chat-history-id");
          var y = elmnt.scrollHeight;
          setTimeout(() => {
          $('#support-chat-history-id').scrollTop(y)
          },100)
          }
        };
        }
      })
    }
  },
  watch:{
    getOrgListDetailsFun(){
      return  this.$store.getters.getLbilChatUserListGetter
    },
    chatSupportListData(newData, oldData){
      if(newData){
        if(newData.length > 0){
          setTimeout(()=>{
            $('.s_chat_list_item').first().addClass('active');
            document.querySelector('.s_chat_list_item.active').click()
            var elmnt = document.getElementById("messagesItem");
            var y = elmnt.clientHeight;
            $('#support-chat-history-id').scrollTop(y)
          },100)
      }
    }
    }
  },
  beforeCreate: function() {
    $('body').addClass('support_chat_reply_page_wrp')
  },
  beforeRouteLeave: function(to, from, next) {
    if(this.socketCheck){
      this.socketCheck.close();
    }
    $('body').removeClass('support_chat_reply_page_wrp')
    next();
  },
}